import React from 'react'
import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

const useStyles = makeStyles(theme => ({
  chip: {
    display: 'flex',
    padding: '2px 8px',
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '18px',
    backgroundColor: GRAY_COLORS[50],
    color: GRAY_COLORS[700],
    whiteSpace: 'nowrap',
    width: 'fit-content',
    gap: 5
  }
}))

const ChipStandard = ({
  children,
  color,
  backgroundColor,
  cursor,
  ...props
}) => {
  const classes = useStyles()
  return (
    <div
      className={classes.chip}
      style={{ color, cursor, backgroundColor }}
      {...props}
    >
      {children}
    </div>
  )
}
export default ChipStandard
